import { useSelector } from "react-redux";
import styles from "./loading.module.scss";

const Loading = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);
  if (!isLoading) return null;

  return (
    <div className={styles.loading_overlay}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default Loading;
